import { render, staticRenderFns } from "./sgsfest.vue?vue&type=template&id=ff11ff22&scoped=true&"
import script from "./sgsfest.vue?vue&type=script&lang=js&"
export * from "./sgsfest.vue?vue&type=script&lang=js&"
import style0 from "./sgsfest.vue?vue&type=style&index=0&id=ff11ff22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff11ff22",
  null
  
)

export default component.exports